import React from 'react';
import { useParams } from 'react-router-dom';

import { Container } from '@gpstrackit/gtc-react-controls';
import { Grid } from '@mui/material';

export const DetailView = () => {

	const params = useParams();
	const id = params.id;

	return (
		<Container maxWidth={false} className="container-view">
			<Grid
				direction="row"
				style={{ padding: 15 }}
			>
				DETAIL VIEW {id}
			</Grid>
		</Container>
	);
}

export default DetailView;